import { TfiAngleRight } from "react-icons/tfi";
import Container from "../layout/Container";
import SliderShow from "./Slider";

const Image = () => {
  return (
    <div>
      <Container>
        <div className="h-[576px] w-[770px] overflow-hidden rounded-md border border-solid border-darkGreen border-opacity-30">
          <div>
            <div className="relative">
              <img
                src="assets/images/auction_listing/auctionimg.png"
                alt="auctionimg"
              />
              <div className="absolute top-[215px] right-4 cursor-pointer rounded-full bg-black bg-opacity-20 py-4 px-4 text-white">
                <TfiAngleRight />
              </div>
            </div>
          </div>
          <div className=" my-4 mt-4 flex w-[770px] items-center justify-center gap-x-5">
            <SliderShow />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Image;
